import './BulkScopeActionBar.scss';
import { AddToTaskSelector } from './AddToTaskSelector';
import { DeleteInitiativeScopeButton } from './DeleteInitiativeScopeButton';
import { Space } from 'antd';
import { useGlobalSelect } from '@hooks';
import React, { useCallback } from 'react';

export interface BulkScopeActionBarProps {
	initiativeId: number;
	selectNamespace: string;
	selectedObjectType: string | undefined;
}

export const BulkScopeActionBar: React.FC<BulkScopeActionBarProps> = ({
	initiativeId,
	selectNamespace,
	selectedObjectType
}) => {
	const { getGlobalSelection, removeSelection } = useGlobalSelect();

	const selections = getGlobalSelection({ namespace: selectNamespace });

	const handleSelectAction = useCallback(() => {
		removeSelection({
			namespace: selectNamespace,
			selections
		});
	}, [ removeSelection, selectNamespace, selections ]);

	if (!selections.length) {
		return null;
	}

	return (
		<Space
			align='end'
			className='bulk-scope-action-bar'>
			<DeleteInitiativeScopeButton
				initiativeId={ initiativeId }
				onDelete={ handleSelectAction }
				selectedObjectType={ selectedObjectType }
				sonarObjectIds={ selections } />
			<AddToTaskSelector
				initiativeId={ initiativeId }
				onSelect={ handleSelectAction }
				selectAllEnabled={ false }
				sonarObjectIds={ selections } />
		</Space>
	);
};
